module.exports = __webpack_public_path__ + "img/SA_provinces.d9791eee.png";